import { render, staticRenderFns } from "./BuscarTurnos.vue?vue&type=template&id=6e55b78a&scoped=true"
import script from "./BuscarTurnos.vue?vue&type=script&lang=js"
export * from "./BuscarTurnos.vue?vue&type=script&lang=js"
import style0 from "./BuscarTurnos.vue?vue&type=style&index=0&id=6e55b78a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e55b78a",
  null
  
)

export default component.exports